const swiper = new Swiper('#js-uservoiceSlide', {
  loop: true,
  speed: 2000,
  autoplay: {
    delay: 3000,
  },
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: 1.3,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 640px
    989: {
      slidesPerView: 4,
      spaceBetween: 20,
      centeredSlides: false,
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
})
